// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__HNSmT","unreadBadge":"styles_unreadBadge__3znUP","modalContent":"styles_modalContent__149Np","modal":"styles_modal__1Qfw6"};